export default __webpack_public_path__ + "static/media/14.e275f27d.jpg";